<!--
 * @Author: chengleilei
 * @Date: 2025-10-09 09:59:41
 * @Description: 批量修改门店维护人-导入弹窗
-->
<template>
    <Modal
        v-model="isShow"
        width="450"
        closable
        footer-hide
        :mask-closable="false"
        title="批量导入门店维护人"
        class="upm"
    >
        <Spin fix v-if="uploading"></Spin>
        <span class="upm-template cup" @click="downloadTemplate">点击下载模板</span>
        <UploadFile
            :custom="true"
            @customFileUpload="customFileUpload"
            ref="uploadFileRef"
            style="margin-top: 10px"
            accept=".xlsx,.xls"
        />
    </Modal>
</template>

<script>
import UploadFile from '@/components/FileUpload/index';
import { apiSalesmanBatchTemplate, apiSalesmanBatchImportFile } from '@/api/store';

export default {
    components: { UploadFile },
    data() {
        return {
            isShow: false,
            uploading: false,
        };
    },
    methods: {
        // 打开弹窗
        open(row) {
            this.isShow = true;
            this.$refs['uploadFileRef'].removeUploadItem(0);
        },
        // 自定义文件上传
        async customFileUpload(file) {
            if (this.uploading) return;
            let data = new FormData();
            data.append('file', file);
            this.uploading = true;
            this.$Message.loading({
                content: '导入中...',
                duration: 0,
            });
            try {
                const res = await apiSalesmanBatchImportFile(data);
                this.uploading = false;
                this.$Message.destroy();
                if (res) {
                    this.$refs['uploadFileRef'].removeUploadItem(0);
                    this.$Notice.warning({
                        title: '文件数据有误',
                        desc: '错误信息已下载，请查看',
                    });
                    this.downLoadByALink(res);
                } else {
                    this.$Message.success({
                        content: '导入成功',
                    });
                    this.isShow = false;
                    this.$emit('uploadSuccess', res);
                }
            } catch (error) {
                this.uploading = false;
                this.$refs['uploadFileRef'].removeUploadItem(0);
                this.$Message.destroy();
            }
        },
        // 下载模板
        async downloadTemplate() {
            this.$Message.loading({
                content: '下载中...',
                duration: 0,
            });
            try {
                const res = await apiSalesmanBatchTemplate();
                this.$Message.destroy();
                this.$Message.success('下载成功');
                this.downLoadByALink(res || '');
            } catch (error) {
                this.$Message.destroy();
            }
        },
        // 下载-通过a连接
        downLoadByALink(url) {
            let aLink = document.createElement('a');
            aLink.href = url || '';
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
        },
    },
};
</script>

<style lang="less" scoped>
.upm {
    .upm-template {
        color: #2d8cf0;
        text-decoration: underline;
    }
}
</style>
